let promise = null;

export const loadGoogleMaps = (lang = "en") => {
  if (window.google && window.google.maps && window.google.maps.places) return Promise.resolve(window.google);
  if (promise) return promise;
  promise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&language=${lang}&loading=async&callback=__gmapsReady`;
    window.__gmapsReady = () => resolve(window.google);
    s.async = true;
    s.onerror = () => { promise = null; reject(new Error("gmaps load failed")); };
    document.head.appendChild(s);
  });
  return promise;
};
